import { Navigate } from "react-router-dom";
import { useRealEstateAuth } from "./RealEstateAuthProvider"

const RealEstatePrivateRoute = ({ children }) => {
    const { isRealEstateAuthenticated }  = useRealEstateAuth();

    if (!isRealEstateAuthenticated) {
        return <Navigate to="/realestate/login" />
    }

    return children;
}

export default RealEstatePrivateRoute